<ng-template #militaryService>
  <div class="card shadow-sm mb-5">
    <div class="card-header">
      <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
    </div>
    <div class="card-body">
      <borrower-military-service #borrowerMilitaryService [borrower]="mainBorrower"></borrower-military-service>
    </div>
  </div>

  @if (!inCoApplyFlow) {
    @for (coBorrower of coBorrowers; track coBorrower.borrowerId) {
      @if (borrowerSetting(coBorrower)) {
        <div class="card shadow-sm mb-5">
          <div class="card-header">
            <h3 class="card-title">{{coBorrower.firstName + " " + coBorrower.lastName}}</h3>
          </div>
          <div class="card-body">
            <borrower-military-service [borrower]="coBorrower"></borrower-military-service>
          </div>
        </div>
      }
    }
  }

</ng-template>

<wizard-step-template [stepMainTemplate]="militaryService" [step]="step" [stepComponent]="this"></wizard-step-template>
